import { Space } from 'antd'
import AppDnD from 'general/components/AppDragAndDrop/AppDnD'
import CustomAntButton from 'general/components/Button/CustomAntButton'
import ContentContainer from 'general/components/ContentContainer'
import FilterPopover from 'general/components/CustomPopover/FilterPopover'
// import SelectOptions from 'general/constants/SelectOptions'
import Utils, { findObjectInArray } from 'general/utils/Utils'
import useFilter from 'hooks/useFilter'
// import { useMemo } from 'react'
import { InvoiceTable } from '../../components/InvoiceTable'
import Modals from '../../components/Modals'
import {
  defaultValues,
  defaultValuesAD,
  defaultValuesPartner,
  filterOptions,
  renderInvoiceType,
} from '../../constant'
import useAppDnD from 'hooks/useAppDnD'
import useGetSerials from 'hooks/Queries/useGetSerials'
// import SelectOptions from 'general/constants/SelectOptions'
import CustomAntInput from 'general/components/Forms/CustomAntInput/CustomAntInput'
import CustomAntSelect from 'general/components/CustomAntSelect'
import { useEffect, useState } from 'react'
import useSearchDebounce from 'hooks/useSearchDebounce'
import {
  useCopyQueryListInvoice,
  useMutationPullBulkMessage,
  useQueryListAccountingDocument,
  useQueryListCompany,
  useQueryListInvoice,
  useQueryListPartner,
} from '../../components/queries'
import _ from 'lodash'
// import { useMutationGetBulkMessage } from 'features/Invoice/screens/ListInvoice/queries'
import { ActionsTable } from '../../components/InvoiceTable/ActionsTable'
import dayjs from 'dayjs'
import PreferenceKeys from 'general/constants/PreferenceKeys'
import { useAppSelector } from 'hooks/useRedux'
import { shallowEqual } from 'react-redux'
import { useTransactionSelector } from 'features/Invoice/screens/ListTransactions/slice'
import { useDispatch } from 'react-redux'
import { unwrapResult } from '@reduxjs/toolkit'
import { thunkFindJobposition } from 'features/Jobposition/jobpositionSlice'
import {
  thunkCopys,
  thunkChangeStatusRemoveInvoice,
  setSelectedAccountingDocument,
} from 'features/Invoice/invoiceSlice'
import ToastHelper from 'general/helpers/ToastHelper'
import axiosClient from 'api/axiosClient'
import reportApi from 'api/reportApi'
import { saveAs } from 'file-saver'
import CustomDataTable from 'general/components/CustomDataTable'
import ModalCompanyConfigs from 'features/TvanHandle/components/ModalCompanyConfigs'
import TableAction from 'general/components/GroupButton/TableAction'
import { IconAction } from 'general/components/GroupButton/styles'
import SelectOptions from 'general/constants/SelectOptions'
import { SpanNotYetReleasedTd } from 'features/TaxDeductionDocuments/styled'
import { thunkCopyAccountingDocuments } from 'features/AccountingDocument/accountDoucmentsSlice'
import ModalCreatePartner from 'features/TvanHandle/components/ModalCreatePartner'
import ModalActiveConnectConsumer from 'features/TvanHandle/components/ModalActiveConnectConsumer'
import Swal from 'sweetalert2'
import partnerApi from 'api/partnerApi'
export const TvanHandlePartner = () => {
  // base state
  const [tvanStateConnect, setTvanStateConnect] = useState({
    show: false,
    value: false,
  })
  const [tvanState, setTvanState] = useState({
    show: false,
    value: false,
  })
  const [modalsState, setModalsState] = useState({ show: false })
  const [disableCopy, setDisableCopy] = useState(false)
  const [disableExport, setDisableExport] = useState(false)
  const [modalsCreate, setModalsCreate] = useState({ show: false })
  const [
    disableChangeStatusRemoveInvoice,
    setDisableChangeStatusRemoveInvoice,
  ] = useState(false)
  const [filterParams, setFilterParams] = useFilter(
    'tvanPartner',
    'gFiltersTvanPartner',
  )
  const { mutate: checkMessages, isPending: checkingBulkMessage } =
    useMutationPullBulkMessage()

  const swalDisconnectConsumer = async (row) => {
    const result = await Swal.fire({
      title: 'Xác nhận',
      html: `Bạn có muốn ngắt kết nối consumer đối tác <b>${row?.userNameRabbitmq ?? ''}</b> không?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Đồng ý',
      cancelButtonText: 'Hủy',
      customClass: {
        confirmButton: 'btn btn-danger font-weight-bolder',
        cancelButton: 'btn btn-light font-weight-bolder',
      },
    })

    if (result.isConfirmed) {
      try {
        // const deleteRes = await companyTitleApi.delete([
        //   companyTitle.companyTitleId,
        // ])
        // const { result: deleteResult } = deleteRes
        // if (deleteResult === 'success') {
        //   ToastHelper.showSuccess(t('Xóa chức danh thành công'))
        //   companyTitleQuery.refetch()
        // }
        let result = await partnerApi
          .pauseInvoiceQueuePartner({ partnerId: row?.partnerId })
          .catch((error) => {
            console.log(error.response?.data)
          })
        refetchListInvoice()
        console.log('result', result)
      } catch (error) {
        console.log(`Delete swalDisconnectConsumer error: ${error?.message}`)
      }
    }
  }

  const defaultColumns = [
    {
      id: 'namePartner',
      name: 'Tên đối tác',
      minWidth: '200px',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            // style={{
            //   textAlign: 'center',
            // }}
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            <span>{row?.namePartner}</span>
          </p>
        )
      },
    },
    {
      id: 'userNameRabbitmq',
      name: 'Tên tài khoản Queue',
      minWidth: '150px',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            style={{
              textAlign: 'center',
            }}
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            <span style={{ color: 'blue' }}>{row?.userNameRabbitmq}</span>
          </p>
        )
      },
    },
    {
      id: 'vhostRabbitmq',
      name: 'Vhost',
      minWidth: '120px',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            style={{
              textAlign: 'center',
            }}
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {`${row?.vhostRabbitmq ?? ''}`}
          </p>
        )
      },
    },
    {
      id: 'status',
      name: 'Trạng thái',
      center: true,
      minWidth: '150px',
      omit: false,
      cell: (row) => {
        const statusConfig = {
          null: {
            label: 'Chưa hoạt động',
            style: {
              backgroundColor: '#FEE2E2',
              color: '#DC2626',
              border: '1px solid #FECACA',
            },
          },
          0: {
            label: 'Chưa hoạt động',
            style: {
              backgroundColor: '#FEE2E2',
              color: '#DC2626',
              border: '1px solid #FECACA',
            },
          },
          1: {
            label: 'Hoạt động',
            style: {
              backgroundColor: '#D1FAE5',
              color: '#047857',
              border: '1px solid #A7F3D0',
            },
          },
          2: {
            label: 'Tạm thời',
            style: {
              backgroundColor: '#FEF3C7',
              color: '#B45309',
              border: '1px solid #FDE68A',
            },
          },
        }

        const status = statusConfig[row?.status] || {
          label: row?.status ?? 'Không xác định',
          style: {
            backgroundColor: '#F3F4F6',
            color: '#4B5563',
            border: '1px solid #E5E7EB',
          },
        }

        return (
          <span
            data-tag="allowRowEvents"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '4px 12px',
              borderRadius: '20px',
              fontSize: '12px',
              fontWeight: 600,
              lineHeight: '18px',
              whiteSpace: 'nowrap',
              ...status.style,
            }}
          >
            {status.label}
          </span>
        )
      },
    },

    {
      id: 'processingLoad',
      name: 'Xử lý',
      center: true,
      minWidth: '220px',
      omit: false,
      cell: (row) => {
        const data = findObjectInArray(
          infotPartners,
          'key',
          row?.keyPassWordRabbitmq,
        )

        const processing = Number(data?.processingProcedure) || 0
        const consumers = Number(data?.consumersHandle) || 0
        const messages = Number(data?.messages) || 0

        return (
          <div
            data-tag="allowRowEvents"
            style={{
              width: '100%',
              padding: '10px 2px',
              fontFamily: 'inherit',
              color: '#1f2937',
            }}
          >
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                gap: 8,
                marginBottom: 8,
              }}
            >
              <span
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 7,
                  fontSize: 12,
                  fontWeight: 600,
                  color: '#374151',
                }}
              >
                <span
                  style={{
                    width: 7,
                    height: 7,
                    borderRadius: '50%',
                    background: '#2563eb',
                    flexShrink: 0,
                  }}
                />
                Xử lý hóa đơn
              </span>

              <span
                style={{
                  padding: '3px 8px',
                  borderRadius: 6,
                  background: '#eff6ff',
                  color: '#1d4ed8',
                  fontSize: 11,
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                }}
              >
                {consumers} luồng
              </span>
            </div>

            <div
              style={{
                display: 'flex',
                alignItems: 'baseline',
                gap: 6,
                marginBottom: 8,
              }}
            >
              <strong
                style={{
                  fontSize: 14,
                  lineHeight: 1.1,
                  fontWeight: 700,
                  letterSpacing: '-0.5px',
                  color: '#111827',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {processing}
              </strong>

              <span style={{ fontSize: 11, color: '#9ca3af' }}>
                hóa đơn xử lý
              </span>
            </div>

            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: 8,
                fontSize: 11,
                whiteSpace: 'nowrap',
              }}
            >
              <span
                style={{
                  display: 'inline-flex',
                  alignItems: 'center',
                  gap: 5,
                  color: '#16a34a',
                }}
              >
                <span
                  style={{
                    width: 6,
                    height: 6,
                    borderRadius: '50%',
                    background: '#16a34a',
                  }}
                />
                Đang chạy: {consumers}
              </span>

              <span style={{ color: '#b7791f' }}>Chờ xử lý: {messages}</span>
            </div>
          </div>
        )
      },
    },
    {
      id: 'queueLoad',
      name: 'Đo tải Queue',
      center: true,
      minWidth: '240px',
      omit: false,
      cell: (row) => {
        const messages = Number(row?.messages ?? 0)
        const messagesReady = Number(row?.messagesReady ?? 0)
        const messagesUnacknowledged = Number(row?.messagesUnacknowledged ?? 0)
        const consumers = Number(row?.consumers ?? 0)
        const status = row?.status ?? 'IDLE'

        const statusConfig = {
          NORMAL: {
            label: 'Bình thường',
            color: '#059669',
            background: '#D1FAE5',
          },
          NO_CONSUMER: {
            label: 'Không có consumer',
            color: '#DC2626',
            background: '#FEE2E2',
          },
          IDLE: {
            label: 'Chờ kết nối',
            color: '#6B7280',
            background: '#F3F4F6',
          },
          PROCESSING: {
            label: 'Đang xử lý',
            color: '#2563EB',
            background: '#DBEAFE',
          },
          BACKLOG: {
            label: 'Tồn đọng',
            color: '#D97706',
            background: '#FEF3C7',
          },
        }

        const config = statusConfig[status] ?? statusConfig.IDLE

        // Ngưỡng hiển thị tải minh họa, có thể điều chỉnh
        const maxMessages = 1000
        const percent = Math.min((messagesReady / maxMessages) * 100, 100)

        const loadColor =
          status === 'NO_CONSUMER'
            ? '#DC2626'
            : percent >= 70
              ? '#D97706'
              : '#059669'

        return (
          <div
            data-tag="allowRowEvents"
            title={row?.statusMessage ?? ''}
            style={{
              width: '100%',
              minWidth: '210px',
              padding: '8px 0',
            }}
          >
            {/* Trạng thái */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                gap: '8px',
                marginBottom: '8px',
              }}
            >
              <span
                style={{
                  padding: '3px 8px',
                  borderRadius: '12px',
                  backgroundColor: config.background,
                  color: config.color,
                  fontSize: '11px',
                  fontWeight: 600,
                  whiteSpace: 'nowrap',
                }}
              >
                {config.label}
              </span>

              <span
                style={{
                  fontSize: '12px',
                  fontWeight: 600,
                  color: '#374151',
                }}
              >
                {messages.toLocaleString('vi-VN')} msg
              </span>
            </div>

            {/* Thanh đo message chờ */}
            <div
              style={{
                height: '6px',
                width: '100%',
                backgroundColor: '#E5E7EB',
                borderRadius: '10px',
                overflow: 'hidden',
              }}
            >
              <div
                style={{
                  height: '100%',
                  width: `${percent}%`,
                  backgroundColor: loadColor,
                  borderRadius: '10px',
                  transition: 'width 0.3s ease',
                }}
              />
            </div>

            {/* Thông số */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                gap: '8px',
                marginTop: '7px',
                fontSize: '11px',
                color: '#6B7280',
              }}
            >
              <span title="Message đang chờ">
                <span style={{ color: '#D97706' }}>●</span> Chờ: {messagesReady}
              </span>

              <span title="Message chưa ACK">
                <span style={{ color: '#2563EB' }}>●</span> Xử lý:{' '}
                {messagesUnacknowledged}
              </span>

              <span title="Số consumer">
                <span style={{ color: '#059669' }}>●</span> Kết nối: {consumers}
              </span>
            </div>

            {/* Mô tả trạng thái */}
            {row?.statusMessage && (
              <div
                style={{
                  marginTop: '5px',
                  fontSize: '11px',
                  color: config.color,
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                }}
                title={row.statusMessage}
              >
                {row.statusMessage}
              </div>
            )}
          </div>
        )
      },
    },
    {
      id: 'keyPassWordRabbitmq',
      name: 'Key',
      center: true,
      omit: false,
      minWidth: '150px',
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.keyPassWordRabbitmq}
          </p>
        )
      },
    },
    {
      id: 'technicalContactEmail',
      name: 'Email',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.technicalContactEmail}
          </p>
        )
      },
    },
    {
      id: 'technicalContactPhone',
      name: 'Số điện thoại',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.technicalContactPhone}
          </p>
        )
      },
    },
    {
      id: 'technicalContactPhone',
      name: 'Số điện thoại',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.technicalContactPhone}
          </p>
        )
      },
    },
    {
      id: 'service',
      name: 'Dịch vụ',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.service}
          </p>
        )
      },
    },
    {
      id: 'sizingDescription',
      name: 'Mô tả nhu cầu muốn kết nối',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.sizingDescription}
          </p>
        )
      },
    },
    {
      id: 'transactionVolumeByPeriodQuarter',
      name: 'Dự kiến lượng GD ngày/tháng/quý',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.transactionVolumeByPeriodQuarter}
          </p>
        )
      },
    },
    {
      id: 'peakDayTransactions',
      name: 'Ngày giao dịch cao điểm',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.peakDayTransactions}
          </p>
        )
      },
    },
    {
      id: 'normalDayTransactions',
      name: 'Ngày giao dịch thông thường',
      center: true,
      omit: false,
      cell: (row) => {
        return (
          <p
            data-tag="allowRowEvents"
            className="text-dark-75 font-weight-normal m-0 text-maxline-3 w-100 "
          >
            {row?.normalDayTransactions}
          </p>
        )
      },
    },
    {
      name: 'Hành động',
      center: true,
      disabled: true,
      compact: true,
      minWidth: '200px',
      grow: 2,
      style: {
        justifyContent: 'flex-end',
      },
      cell: (row) => {
        // 👇 sau đó return JSX
        return (
          <>
            {!row?.status ? (
              <TableAction
                titleActionText="Cho phép kết nối consumer, đối tác có thể reconect để lấy message về"
                icon={<IconAction className="fa-solid fa-plug" />}
                onClick={() => {
                  setTvanStateConnect({
                    show: true,
                    value: row,
                  })
                }}
              />
            ) : (
              <></>
            )}
            {row?.status == 1 ? (
              <TableAction
                titleActionText="Ngắt kết nối consumer của đối tác, không xóa message"
                icon={<IconAction className="fa-solid fa-unlink" />}
                onClick={() => {
                  swalDisconnectConsumer(row)
                }}
              />
            ) : (
              <></>
            )}
          </>
        )
      },
    },
  ]
  const dynamicColumns = useAppDnD(defaultColumns)

  const { clearSelectedRows, selectedRows } = useTransactionSelector()

  const handleChange = ({ key, value }) => {
    const cloneTvanState = { ...tvanState }
    cloneTvanState[key] = value
    setTvanState(cloneTvanState)
  }
  const handleChangeModalState = ({ key, value }) => {
    const cloneModasState = { ...modalsState }
    cloneModasState[key] = value
    setModalsState(cloneModasState)
  }
  // hiển thị
  // Gán dữ liệu ban đầu
  useEffect(() => {
    const cloneTvanState = { ...tvanState }
    cloneTvanState.keySearch =
      cloneTvanState.keySearch ?? filterOptions[0].value
    setTvanState(cloneTvanState)
  }, [])

  const dispatch = useDispatch()

  // lấy danh sách hóa đơn
  const { debouncedSearch, search, setSearch } = useSearchDebounce('')
  const {
    listData,
    total,
    isGettingListData,
    isRefetching,
    infotPartners,
    refetchListInvoice,
  } = useQueryListPartner({
    ...filterParams,
    [tvanState.keySearch]: debouncedSearch,
    // [tvanState.keySearch]: tvanState.searchValue,
  })

  // Làm mới dữ liệu hóa đơn
  useEffect(() => {
    refetchListInvoice()
  }, [
    filterParams,
    refetchListInvoice,
    tvanState.keySearch,
    tvanState.searchValue,
    debouncedSearch,
  ])

  // const { data: dataCopys, copyRefetch } = useCopyQueryListInvoice({
  //   invoiceIds: [-1],
  // })

  const changeStatusRemoveInvoiceRefetch = async () => {
    setDisableChangeStatusRemoveInvoice(true)
    const invoiceIds = selectedRows.map((item) => item.invoiceId)
    const result = unwrapResult(
      await dispatch(thunkChangeStatusRemoveInvoice({ invoiceIds })),
    )
    setDisableChangeStatusRemoveInvoice(false)
    if (result?.result === 'success') {
      ToastHelper.showSuccess(
        `Cập nhật trạng thái đã xóa cho ${invoiceIds.length} hóa đơn thành công`,
      )
      refetchListInvoice()
    } else {
      ToastHelper.showError(
        `Cập nhật trạng thái đã xóa cho ${invoiceIds.length} hóa đơn thất bại`,
      )
    }
  }

  const buttonGroups = [
    // {
    //   text: 'Nhân bản',
    //   icon: 'fa-light fa-check',
    //   color: '#3CC65E',
    //   onClick: () => {
    //     copyRefetch()
    //   },
    // },
    // {
    //   text: 'Đổi trạng thái đã xóa',
    //   icon: 'fa-light fa-check',
    //   color: '#ee2334',
    //   onClick: () => {
    //     // changeStatusRemoveInvoiceRefetch()
    //   },
    // },
  ]

  const { selectedAccountingDocument, toggledClearRows, modalStates } =
    useAppSelector((state) => state.invoice, shallowEqual)

  const copyRefetch = async () => {
    setDisableCopy(true)
    const accounting_documentsIds = selectedAccountingDocument.map(
      (item) => item.accounting_documentsId,
    )
    console.log('accounting_documentsIds', accounting_documentsIds)
    const result = unwrapResult(
      await dispatch(thunkCopyAccountingDocuments({ accounting_documentsIds })),
    )
    console.log('result', result)
    setDisableCopy(false)
    if (result?.message === 'success') {
      ToastHelper.showSuccess(
        `Nhân bản ${result.countSucess} chứng từ thành công`,
      )
      refetchListInvoice()
    } else {
      ToastHelper.showError(
        `Nhân bản ${accounting_documentsIds.length} chứng từ thất bại`,
      )
    }
  }

  // Lọc
  // bảng
  // kéo mã
  // chuyển về gửi lỗi
  // cập nhật thông điệp
  return (
    <ContentContainer wrapperClassName={'list-issued-ticket'}>
      <ContentContainer.Header
        titleContent={'Danh sách đối tác'}
        toolBar={
          <Space className="d-flex">
            <CustomAntButton
              text={'Thêm mới'}
              iconCn="fa-regular fa-plus"
              antProps={{
                type: 'primary',
                onClick: () => {
                  setModalsCreate({ show: true })
                },
              }}
            />
            <AppDnD
              defaultColumns={defaultColumns}
              localStorageName={PreferenceKeys.TvanHandleCompany}
            />
          </Space>
        }
      />
      <Space className="ml-5">
        <Space>
          <CustomAntInput
            type="search"
            borderRadius="sm"
            width={150}
            inputProps={{
              value: search,
              onChange: (e) => {
                setSearch(e.target.value)
                // set page is 1 when search
                setFilterParams({ page: 1 })
              },
            }}
          />
        </Space>
      </Space>
      <ContentContainer.Body>
        {selectedAccountingDocument &&
          selectedAccountingDocument.length > 0 && (
            <div className="row">
              {buttonGroups.map((bg) => (
                <div className="col-sm-1" style={{ marginRight: '40px' }}>
                  <CustomAntButton
                    key={bg.text}
                    text={
                      bg.text + ' (' + selectedAccountingDocument.length + ')'
                    }
                    fontSizeText={12}
                    iconCn={bg.icon}
                    color={bg.color}
                    antProps={{
                      danger: bg.danger,
                      disabled:
                        bg.text == 'Nhân bản'
                          ? disableCopy
                          : disableChangeStatusRemoveInvoice,
                      type: bg.type ?? 'primary',
                      className: Utils.cn(
                        bg.className,
                        bg.disabled ? 'disabled' : '',
                      ),
                      onClick: bg.onClick,
                    }}
                  />
                </div>
              ))}
            </div>
          )}
        <br />
        <CustomDataTable
          columns={dynamicColumns}
          dataSource={listData}
          isLoading={isGettingListData || isRefetching}
          isClickable
          handleDoubleClickRow={(row) => {}}
          pagination={{
            total: total,
            rowsPerPage: filterParams.limit,
            currentPage: filterParams.page,
            onChangePage: (page) => {
              setFilterParams({
                page,
              })
            },
            onChangeRowsPerPage: (limit) => {
              setFilterParams({
                limit,
                page: 1,
              })
            },
          }}
          isSelectable
          selectedRows={{
            clearSelectedRows: toggledClearRows,
            selectableRowSelected: (row) => {
              _.includes(selectedAccountingDocument, row)
            },
            handleSelectedRows: ({ selectedRows }) => {
              dispatch(setSelectedAccountingDocument(selectedRows))
            },
          }}
        />

        <ModalActiveConnectConsumer
          modalsState={tvanStateConnect}
          setModalsState={setTvanStateConnect}
          refetchList={refetchListInvoice}
        />
      </ContentContainer.Body>

      <ModalCreatePartner
        show={modalsCreate?.show}
        onClose={() => {
          setModalsCreate({ ...modalsCreate, show: false })
        }}
        refetchList={refetchListInvoice}
      />
    </ContentContainer>
  )
}
